import React, { useState } from "react";
import { Button, Text, Modal, Icon } from "@nimbus-ds/components";
import { QuestionCircleIcon } from "@nimbus-ds/icons";
import { FormattedMessage } from "react-intl";
import useLocalizedImage from "../utils/getLocalizedImage";

const CustomTooltip = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const getImage = useLocalizedImage();

  const openModal = () => {
    setIsOpen(true);
    setCurrentStep(1); // Reset to the first step when opening the modal
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleBegin = () => {
    closeModal(); // Close the modal when clicking "Begin"
  };

  const getModalTitle = () => {
    switch (currentStep) {
      case 1:
        return `¡Bienvenido ${props.storeInfo.name}!`;
      case 2:
        return "Nuestra UI";
      case 3:
        return "Gestión de Productos";
      case 4:
        return "Condicion y Habilitado";
      default:
        return "";
    }
  };

  return (
    <div>
      <Button appearance="transparent" onClick={openModal}>
        <Icon
          color="primary-textLow"
          source={<QuestionCircleIcon size="small" />}
        />
      </Button>

      <Modal open={isOpen} onDismiss={closeModal}>
        <div className="tn-tooltip-container">
          <React.Fragment key=".0">
            <div className="tn-tooltip-title">
              <Modal.Header
                title={getModalTitle()}
                className="custom-modal-header-title"
              />
            </div>
            <Modal.Body padding="none">
              {currentStep === 1 && (
                <div className="tn-intro-main-container">
                  <div className="tn-intro-img-container">
                    <img
                      src={getImage("welcomeImage")}
                      alt="tnwelcome"
                      className="tn-intro-img"
                    />
                  </div>
                  <div>
                    <Text textAlign="center">
                      <FormattedMessage
                        id="tutorial.welcomeMessage"
                        defaultMessage="Welcome Prop, this is a tutorial to help you learn to manage our admin panel. Here you will find all the necessary steps to get the most out of our tools. Let's get started!"
                      />
                    </Text>
                  </div>
                  <div className="tn-intro-button">
                    <Button appearance="primary" onClick={handleNext}>
                      <FormattedMessage
                        id="button.start"
                        defaultMessage="Let's start!"
                      />
                    </Button>
                  </div>
                </div>
              )}
              {currentStep === 2 && (
                <React.Fragment>
                  <div className="tn-steptwo-firstinfo">
                    <img
                      src={getImage("infoPanelOne")}
                      alt="tninfopanel"
                      className="tn-steptwo-first-img"
                    />
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.filterProducts"
                        defaultMessage="You can filter your products by name in the search bar, or you can search for your unclassified products to activate them or reactivate those you have paused."
                      />
                    </Text>
                  </div>
                  <hr />
                  <div className="tn-steptwo-secondinfo">
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.manageGuides"
                        defaultMessage="Para dar de alta tus guías tenes que visitar nuestro sitio, una vez creadas, las podras gestionar aqui. Para obtener tu catalogo actual, tenes que usar el boton de sincronizar, despues de dar de alta tus productos, no te olvides de guardar tus cambios."
                      />
                    </Text>
                    <img
                      src={getImage("buttonsLine")}
                      alt="tninfopanel"
                      className="tn-steptwo-second-img"
                    />
                  </div>
                  <div className="tn-steptwo-buttons-container">
                    <Button appearance="neutral" onClick={handleBack}>
                      <FormattedMessage
                        id="button.back"
                        defaultMessage="Atras"
                      />
                    </Button>
                    <Button appearance="primary" onClick={handleNext}>
                      <FormattedMessage
                        id="button.next"
                        defaultMessage="Siguiente"
                      />
                    </Button>
                  </div>
                </React.Fragment>
              )}
              {currentStep === 3 && (
                <React.Fragment>
                  <div className="tn-stepthree-firstexp">
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.selectMultipleProducts"
                        defaultMessage="Podes elegir varios productos y asociarles un codigo de guía o fit en simultaneo."
                      />
                    </Text>
                    <img
                      src={getImage("guideExample")}
                      alt="severalguides"
                      className="tn-uploadguide-img"
                    />
                  </div>
                  <hr />
                  <div className="tn-stepthree-secondexp">
                    <img
                      src={getImage("guideExampleTwo")}
                      alt="severalguides"
                      className="tn-modify-image-exp"
                    />
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.applyGuideFitCode"
                        defaultMessage="Una vez elegido el Codigo de guía y fit, se aplicaran a todos tus productos seleccionados."
                      />
                    </Text>
                  </div>
                  <div className="tn-steptwo-buttons-container">
                    <Button appearance="neutral" onClick={handleBack}>
                      <FormattedMessage
                        id="button.back"
                        defaultMessage="Atras"
                      />
                    </Button>
                    <Button appearance="primary" onClick={handleNext}>
                      <FormattedMessage
                        id="button.next"
                        defaultMessage="Siguiente"
                      />
                    </Button>
                  </div>
                </React.Fragment>
              )}
              {currentStep === 4 && (
                <React.Fragment>
                  <div className="tn-stepfour-firstexp">
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.registerProductsIndividually"
                        defaultMessage="Podes dar de alta productos también de manera individual, no te olvides de guardar los cambios realizados."
                      />
                    </Text>
                    <img
                      src={getImage("regularUpload")}
                      alt="severalguides"
                      className="tn-product-uploadimg"
                    />
                  </div>
                  <hr />
                  <div className="tn-stepfour-secondexp">
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.productActivation"
                        defaultMessage="Una vez que clasificaste tu producto, este se activara, en cualquier momento puede ser pausado. Tambien podes sincronizar productos individualmente."
                      />
                    </Text>
                    <img
                      src={getImage("activateImage")}
                      alt="severalguides"
                      className="tn-third-image-exp"
                    />
                    <Text textAlign="left">
                      <FormattedMessage
                        id="text.onceClassified"
                        defaultMessage="Una vez clasificados tus productos, estos quedaran
                      habilitados. Pueden ser pausados en cualquier momento."
                      />
                      <br />
                      <FormattedMessage
                        id="text.individualSync"
                        defaultMessage="Los productos pueden ser sincronizados individualmente."
                      />
                    </Text>
                  </div>
                  <div className="tn-steptwo-buttons-container">
                    <Button appearance="neutral" onClick={handleBack}>
                      <FormattedMessage
                        id="button.back"
                        defaultMessage="Atras"
                      />
                    </Button>
                    <Button appearance="primary" onClick={handleBegin}>
                      <FormattedMessage
                        id="button.begin"
                        defaultMessage="Comenzar"
                      />
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </Modal.Body>
          </React.Fragment>
        </div>
      </Modal>
    </div>
  );
};

export default CustomTooltip;
